import type { ChangeRequestResponseModel, MergeBlockedReason } from "@istari/istari-client";

import type { BranchId } from "~/branching/model/branch";
import type { ChangeRequest, ChangeRequestApproval, ChangeRequestId } from "~/change-request/model/change-request";

export function toChangeRequest(dto: ChangeRequestResponseModel): ChangeRequest {
  const base = {
    id: dto.changeRequestId as ChangeRequestId,
    title: dto.title ?? undefined,
    description: dto.description ?? undefined,
    sourceBranchId: dto.sourceTagId as BranchId,
    targetBranchId: dto.targetTagId as BranchId,
    createdById: dto.createdById,
    created: dto.created,
    approvals: dto.approvals.map(({ approverId, sourceTagRevisionId, approvedAt }): ChangeRequestApproval => ({
      approverId,
      sourceTagRevisionId,
      approvedAt,
    })),
    requiredApprovals: dto.requiredApprovals,
    countedApprovals: dto.countedApprovals,
    mergeBlockedReason: dto.mergeBlockedReason === null ? null : toMergeBlockedReason(dto.mergeBlockedReason),
  };

  switch (dto.status) {
    case "OPEN":
      return {
        ...base,
        status: "open",
        sourceSnapshotId: dto.currentSourceSnapshotId,
        targetSnapshotId: dto.currentTargetSnapshotId,
      };
    case "MERGED":
      return {
        ...base,
        status: "merged",
        sourceSnapshotId: dto.sourceSnapshotIdAtMerge,
        targetSnapshotId: dto.targetSnapshotIdAfterMerge,
      };
    case "CLOSED":
      return { ...base, status: "closed", sourceSnapshotId: null, targetSnapshotId: null };
  }
}

function toMergeBlockedReason(reason: MergeBlockedReason): ChangeRequest["mergeBlockedReason"] {
  switch (reason) {
    case "APPROVAL_REQUIRED":
      return "approval-required";
    default: {
      const unknownReason: never = reason;
      console.error("[change-request] unknown merge blocked reason", unknownReason);
      return null;
    }
  }
}
